module.exports = __webpack_public_path__ + "h5/img/mobile_qrcode.19a072f2.jpg";